import { render, staticRenderFns } from "./TeamAddForm.vue?vue&type=template&id=73d10d81&scoped=true&"
import script from "./TeamAddForm.vue?vue&type=script&lang=js&"
export * from "./TeamAddForm.vue?vue&type=script&lang=js&"
import style0 from "./TeamAddForm.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TeamAddForm.vue?vue&type=style&index=1&id=73d10d81&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73d10d81",
  null
  
)

export default component.exports